import { useEffect } from "react"
import { window, document } from "browser-monads"
import { hotjarPages } from "@src/utils/constants/hotjar-pags"

const HotjarScript = () => {
  useEffect(() => {
    const loadHotjar = () => {

      if (typeof window.hj === "function") {
        console.log("Hotjar is already loaded, skipping...")
        return
      }

      if (hotjarPages.includes(window.location.pathname)) {
        (function (h, o, t, j, a, r) {
          h.hj =
            h.hj ||
            function () {
              (h.hj.q = h.hj.q || []).push(arguments)
            }
          h._hjSettings = { hjid: 5131986, hjsv: 6 }
          a = o.getElementsByTagName("head")[0]
          r = o.createElement("script")
          r.async = 1
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
          a.appendChild(r)
          console.log("Hotjar script loaded")
        })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=")
      }
    }

    const delay = setTimeout(() => {
      loadHotjar()
    }, 4000)

    return () => clearTimeout(delay)
  }, [])

  return null
}

export default HotjarScript
